// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-opt[data-v-6e89a4c4]{padding:0 5px}.footerloader[data-v-6e89a4c4]{padding:3px 20px;font-style:italic}", ""]);
// Exports
module.exports = exports;
